import { FC, useContext, useMemo } from 'react'
import { useQuery } from 'react-query'
import {
  QUERIES,
  WithChildren,
  createResponseContext,
  initialQueryResponse,
  stringifyRequestQuery,
} from '../../../../../../_metronic/helpers'
import { useModal } from '../../../../../components'
import { EscalaList } from '../../core/_models'
import { getEscalasEmpresa } from '../../core/_requests'
import { ParamsEscalaEmpresa, useQueryRequest } from './QueryRequestProvider'

const QueryResponseContext = createResponseContext<EscalaList>(initialQueryResponse)

export const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { isOpen } = useModal()
  const { state } = useQueryRequest<ParamsEscalaEmpresa>()
  const empresa = state.params?.empresa

  const query = useMemo(() => stringifyRequestQuery(state), [state])

  const {
    isFetching,
    isError,
    refetch,
    data: response,
  } = useQuery(
    [QUERIES.ESCALAS_EMPRESA_LIST, empresa, query],
    () => getEscalasEmpresa(empresa!, query),
    {
      // Toda rota do eixo empresa é escopada por `{empresa}` (row-level por
      // `empresa.id`): sem empresa escolhida não há o que consultar.
      enabled: Boolean(empresa) && !isOpen,
      cacheTime: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    }
  )

  return (
    <QueryResponseContext.Provider
      value={{ isLoading: isFetching, isError, refetch, response, query }}
    >
      {children}
    </QueryResponseContext.Provider>
  )
}

export const useQueryResponse = () => useContext(QueryResponseContext)
